export const hexToRgba = (color, alpha) => {
  if (!color) return `rgba(0, 0, 0, ${alpha})`;
  
  if (color.startsWith('rgb')) {
    const matches = color.match(/\d+(\.\d+)?/g);
    if (matches && matches.length >= 3) {
      const r = matches[0];
      const g = matches[1];
      const b = matches[2];
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }
  }
  
  let hex = color.replace('#', '');
  if (hex.length === 3) {
    hex = hex.split('').map(char => char + char).join('');
  }
  
  const r = parseInt(hex.slice(0, 2), 16) || 0;
  const g = parseInt(hex.slice(2, 4), 16) || 0;
  const b = parseInt(hex.slice(4, 6), 16) || 0;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const SELECTED_GLOW = {
  shadowColor: '#3B82F6',
  shadowBlur: 18,
  shadowOpacity: 0.7,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
};
